import { ca } from '@cian/analytics';
import { MAX_REALTORS } from './constants';

export interface ITrackFormBaseEventProps {
  action: string;
  label: string;
  type: number | number[];
  name?: string;
}

export interface ITrackFormEventProps {
  type: number;
  amountSelectedRealtors: number;
}

export interface ITrackBaseRealtorProps extends ITrackFormEventProps {
  action: string;
}

export const trackEvent = (props: ITrackFormBaseEventProps) => {
  const { action, label, type, name = 'oldevent' } = props;

  ca('eventSite', {
    name,
    category: 'Application_to_realtor',
    action,
    label,
    page: {
      pageType: 'application_form',
      extra: {
        type,
      },
    },
  });
};

export const trackBaseRealtor = ({ type, amountSelectedRealtors, action }: ITrackBaseRealtorProps) => {
  trackEvent({
    label: `isRequired/default/${amountSelectedRealtors}`,
    action,
    type,
  });
};

export const trackSelectRealtor = ({ type, amountSelectedRealtors }: ITrackFormEventProps) => {
  const action = 'Click_realtor';
  trackBaseRealtor({ type, amountSelectedRealtors, action });
};

export const trackUnselectRealtor = ({ type, amountSelectedRealtors }: ITrackFormEventProps) => {
  const action = 'Click_realtor_deselect';
  trackBaseRealtor({ type, amountSelectedRealtors, action });
};

export const trackMaxRealtors = ({ type, amountSelectedRealtors }: ITrackFormEventProps) => {
  if (amountSelectedRealtors === MAX_REALTORS) {
    const action = 'Click_max_realtor';
    trackBaseRealtor({ type, amountSelectedRealtors, action });
  }
};

export const trackSendForm = (type: number[]) => {
  trackEvent({
    label: `isRequired/default/${type.length}`,
    action: 'Send_application',
    type,
    name: 'newpage',
  });
};
